import { Link } from "react-router-dom";
import { naira, API } from "@/lib/api";
import { Clock, Eye } from "lucide-react";
import { AiBadge } from "@/components/AiBadge";
import { PublishingBadge } from "@/components/PublishingBadge";

const FALLBACK_POSTERS = [
  "https://images.pexels.com/photos/16516724/pexels-photo-16516724.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=600",
  "https://images.pexels.com/photos/13417077/pexels-photo-13417077.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=600",
  "https://images.pexels.com/photos/30743729/pexels-photo-30743729.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=600",
  "https://images.pexels.com/photos/30713505/pexels-photo-30713505.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=600",
  "https://images.pexels.com/photos/30704104/pexels-photo-30704104.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=600",
];

export default function FilmCard({ film, index = 0, fluid = false }) {
  const posterUrl = film?.poster_path
    ? `${API}/films/${film.id}/poster`
    : FALLBACK_POSTERS[index % FALLBACK_POSTERS.length];

  return (
    <Link
      to={`/film/${film.id}`}
      className={`group relative shrink-0 snap-start ${fluid ? "w-full" : "w-[180px] sm:w-[220px]"}`}
      data-testid={`film-card-${film.id}`}
    >
      <div className="relative aspect-[2/3] overflow-hidden rounded-lg border border-white/10 bg-surface">
        <img
          src={posterUrl}
          alt={film.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          onError={(e) => {
            e.currentTarget.src = FALLBACK_POSTERS[index % FALLBACK_POSTERS.length];
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/20 to-transparent opacity-80 group-hover:opacity-95 transition-opacity" />
        <div className="absolute top-2 left-2 z-10 flex flex-col items-start gap-1">
          <PublishingBadge film={film} />
          <AiBadge film={film} />
        </div>
        <div className="absolute top-2 right-2 px-2 py-1 rounded-md bg-ink/80 backdrop-blur text-xs font-display font-bold text-gold border border-gold/20">
          {naira(film.price_naira)}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3 space-y-1">
          <h3 className="font-display font-bold text-white text-sm leading-tight line-clamp-2">
            {film.title}
          </h3>
          <div className="flex items-center gap-3 text-xs text-white/70">
            <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {film.duration_minutes}m</span>
            <span className="capitalize">{film.genre}</span>
            {typeof film.views === "number" && (
              <span className="flex items-center gap-1 ml-auto"><Eye className="w-3 h-3" /> {film.views}</span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}
